import extractData from "./extract-options.js";

function handleSnakeRegex(match, lower, upper) {
	return `${lower}-${upper.toLowerCase()}`;
}

// presumes incoming camelCase!
function buildSelector(pluginName) {
	const snaked = pluginName.replace(/([a-z])([A-Z])/g, handleSnakeRegex);
	return `[data-${snaked}]`;
}

export default function(pluginName, pluginClass, providedElements) {
	const selector = buildSelector(pluginName);

	return function(instanceOptions = {}) {
		const elements = providedElements
			? [...providedElements]
			: [...document.querySelectorAll(selector)];

		return elements.map(element => {
			// Poor old webpack config will choke on spread operator
			const options = Object.assign(
				{},
				pluginClass.DEFAULTS,
				instanceOptions,
				extractData(pluginName, element)
			);
			return new pluginClass(element, options);
		});
	};
}



// WEBPACK FOOTER //
// ./client/src/core/lib/vanilla-plugin.js